// extracted by mini-css-extract-plugin
module.exports = {"thankyou":"styles_thankyou__9l5c9"};